import { render, staticRenderFns } from "./OrgUserSelection.vue?vue&type=template&id=4ccca5a2"
import script from "./OrgUserSelection.vue?vue&type=script&lang=js"
export * from "./OrgUserSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports